module.exports = __webpack_public_path__ + "img/mex.8ee3aa6a.svg";